import * as knockoutNamespace from 'knockout';

const ko =
    (knockoutNamespace as unknown as {default?: typeof knockoutNamespace}).default ?? knockoutNamespace;

declare global {
    interface Window {
        ko: typeof ko;
    }
}

const globalRef = globalThis as typeof globalThis & {ko?: typeof ko};
if (!globalRef.ko) {
    globalRef.ko = ko;
}

export {ko};
